import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Recaptcha from 'react-recaptcha';
import axios from 'axios';


const validationSchema = Yup.object().shape({
  email: Yup.string().email('E-mail is not valid.').required('E-mail is required.'),
  email_confirmation: Yup.string().oneOf([Yup.ref('email'), null], "E-mails must match.").required('E-mail confirmation is required.'),
  full_name: Yup.string().required("Full name is required"),
  zipcode: Yup.string().required("ZIP Code is required."),
  message: Yup.string().required("A message is required."),
  recaptcha: Yup.string().required("Please verify.")

})

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  render () {
    return (
      <div>
        <Formik
          initialValues={{ email: '', email_confirmation: '', full_name: '', zipcode: '', message: '', recaptcha: '' }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            let csrfToken = document.querySelectorAll('meta[name=csrf-token]')[0].getAttribute("content");
            axios.post("/contact_form", values, { headers: { 'X-CSRF-Token' : csrfToken }}).then((response)=>{
              console.log(response);
              window.location.reload();
            }).catch(function (error) {
              console.log(error);
            });
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
            <form onSubmit={handleSubmit} id="contactForm">
              <div className="f-row">
                <div className="col-fsm-6">
                  <div className="form-group">
                    <label>Email Address:</label>
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      className="form-control"
                      placeholder="Email Address:"
                    />
                    {errors.email && touched.email && (<div className="form__error--text">{errors.email}</div>)}
                  </div>
                </div>

                <div className="col-fsm-6">
                  <div className="form-group">
                    <label>Confirm Email:</label>
                    <input
                      type="text"
                      name="email_confirmation"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email_confirmation}
                      className="form-control"
                      placeholder="Confirm Email:"
                    />
                    {
                      errors.email_confirmation && touched.email_confirmation && (<div className="form__error--text">{errors.email_confirmation}</div>)
                    }
                  </div>
                </div>

                <div className="col-fsm-6">
                  <div className="form-group">
                    <label>Full Name:</label>
                    <input
                      type="text"
                      name="full_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.full_name}
                      className="form-control"
                      placeholder="Full Name:"
                    />
                    {errors.full_name && touched.full_name && (<div className="form__error--text">{errors.full_name}</div>)}
                  </div>
                </div>

                <div className="col-fsm-6">
                  <div className="form-group">
                    <label>ZIP Code:</label>
                    <input
                      type="text"
                      name="zipcode"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.zipcode}
                      className="form-control"
                      placeholder="ZIP Code:"
                    />
                    {errors.zipcode && touched.zipcode && (<div className="form__error--text">{errors.zipcode}</div>)}
                  </div>
                </div>

                <div className="col-fsm-12">
                  <div className="form-group">
                    <label>Message:</label>
                    <textarea
                      name="message"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.message}
                      className="form-control"
                      rows="5"
                      placeholder="Message"
                    />
                    {errors.message && touched.message && (<div className="form__error--text">{errors.message}</div>)}
                  </div>
                </div>
                <div className="col-fsm-12">
                  <div className="mb-2">
                    <Recaptcha
                      sitekey="6Ldvt5QUAAAAAA0UxjaswGIEAaOYW2KOLLF5XLWO"
                      render="explicit"
                      verifyCallback={(response) => { setFieldValue("recaptcha", response); }}
                      expiredCallback={(response) => { setFieldValue("recaptcha", ''); }}
                      onloadCallback={() => console.log('recaptcha rendered')}
                    />
                    {errors.recaptcha && touched.recaptcha && (<div className="form__error--text">{errors.recaptcha}</div>)}
                  </div>
                  <div>
                    <button type="submit" disabled={isSubmitting} className="btn btn-solid block my-3 w-button-lg mx-auto">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    )
  }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./app/javascript/bundles/main/components/ContactForm.jsx